<template>
    <relatorio-risco objetivo="reprovacao" titulo="RELATÓRIO DE RISCO DE REPROVAÇÃO"></relatorio-risco>
</template>

<script>
import RelatorioRisco from '@/components/relatorio/shared/relatorio-risco'

// BLOCO K — item 140. Só fixa o objetivo; a lógica vive no componente compartilhado.
export default {
    name: 'RelatorioRiscoReprovacao',
    components: { RelatorioRisco }
}
</script>
